export default __webpack_public_path__ + "static/media/15.a95b27e7.png";